/* TZAMPAS — fügt html.tz-scrolled hinzu, sobald gescrollt wird.
   Steuert u. a. das Wachsen des Header-Logos beim Scrollen. */
(function () {
  var root = document.documentElement;
  var THRESHOLD = 60;
  var ticking = false;
  function update() {
    if (window.scrollY > THRESHOLD) {
      root.classList.add('tz-scrolled');
    } else {
      root.classList.remove('tz-scrolled');
    }
    ticking = false;
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
